import type { PartyType, VendorKind } from '@/lib/auth/session';
import { menuFor } from '@/lib/menu';
import type { VendorRfqRow } from '@/lib/types';

/**
 * 관문 칸의 「New N」 (사용자 지시 2026-11-04 「로그인 페이지에서도 신규 소식이 있으면 그 버튼 우측 상단에」).
 *
 * <p>새 API 를 만들지 않는다 — 사이드바 배지({@code useTodoCounts})를 <b>배정된 현장마다</b> 돌려 더한다.
 * 같은 쿼리·같은 규칙이라 관문의 숫자와 들어간 뒤의 배지가 어긋나지 않는다.
 *
 * <p>갈래 칸마다 <b>그 갈래의 메뉴에 있는 항목만</b> 센다({@link menuFor}). 구매 칸에 TBM 서명이 붙으면
 * 눌러 들어가도 그 메뉴가 없다.
 */
export function newsForKind(
  partyType: PartyType,
  kind: VendorKind,
  perSite: Array<Record<string, number>>,
): number {
  const keys = menuFor(partyType, [kind]).flatMap((group) => group.items.map((item) => item.key));
  return perSite.reduce((sum, counts) => sum + keys.reduce((acc, key) => acc + (counts[key] ?? 0), 0), 0);
}

/** 견적·입찰 칸 — 마감 전이고 아직 답하지 않은(참가 의사도 응찰도 없는) 공고. */
export function newRfqCount(rows: VendorRfqRow[]): number {
  return rows.filter((row) => !row.closed && !row.mySubmitted && row.intent === null).length;
}
